import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";
import SectionLabel from "@/components/SectionLabel";

export default function Shop() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.products().then((r) => setProducts(r.products)).catch(() => {}); }, []);
  return (
    <div className="max-w-site mx-auto px-6 md:px-10 py-16 md:py-24" data-testid="shop-page">
      <div className="mb-12">
        <SectionLabel index="01 / Shop">The Vitura lineup.</SectionLabel>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl tracking-[-0.03em] leading-[0.95] mt-6">
          One formula. <span className="editorial normal-case">Two expressions.</span>
        </h1>
        <p className="mt-5 max-w-xl text-[15px] text-[color:var(--ink-2)]">
          The same 15 clinically dosed actives, finished in two different flavor moods. Pick the one that matches your morning.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 border border-[color:var(--line)]">
        {products.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08}>
            <Link to={`/preview/product/${p.handle}`} className="group block relative p-8 md:p-12 border-b md:border-b-0 md:border-r last:border-r-0 last:border-b-0 border-[color:var(--line)] overflow-hidden" data-testid={`shop-card-${p.handle}`}>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500" style={{ background: `radial-gradient(60% 60% at 50% 40%, ${p.color}55, transparent 70%)` }} />
              <div className="relative flex items-start justify-between">
                <div>
                  <div className="label !text-[10px]">No. 00{i + 1}</div>
                  <h3 className="font-display text-3xl md:text-4xl tracking-[-0.02em] mt-2">{p.flavor}</h3>
                  <p className="editorial text-lg text-[color:var(--ink-2)] mt-2">{p.tagline}</p>
                </div>
                <span className="w-2.5 h-2.5" style={{ background: p.color }} />
              </div>
              <div className="relative mt-10 aspect-[5/4] flex items-center justify-center">
                <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, ${p.color_soft} 0%, transparent 100%)` }} />
                <img src={p.images[0]} alt={p.flavor} className="relative max-h-[80%] object-contain transition duration-700 group-hover:-translate-y-2" />
              </div>
              <div className="relative mt-6 flex items-center justify-between">
                <div className="text-sm">From <span className="font-display">${p.variants[0].price.toFixed(0)}</span></div>
                <span className="label group-hover:opacity-60 transition">Shop →</span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
